const cyclicVoltaJcamp3 = `
##TITLE=Cyclic Voltammetry
##JCAMP-DX=5.00 $$ chemotion-converter-app (0.1.0)
##DATA TYPE=CYCLIC VOLTAMMETRY
##DATA CLASS=XYDATA
##ORIGIN=
##OWNER=
##XUNITS=V vs Ref
##YUNITS=Ampere
##TYPE=PalmSens.DataFiles.SessionFile
##TIMESTEP=636506816837276482
##DEVICEUSED=6
##DEVICESERIAL=ES3 16X965
##FIRSTX=4.99413E-05
##LASTX=-0.00994404
##MINX=-1.80885
##MAXX=1.80895
##MINY=-0.000226347
##MAXY=0.000371349
##NPOINTS=724
##FIRSTY=3.43162e-06
##XUNITS=V vs Ref
##YUNITS=Ampere
##XYDATA=(XY..XY)
4.99413E-05, 3.43162e-06
0.0100439, 2.43098e-06
0.0200379, 2.07409e-06
0.0300315, 1.9115899999999998e-06
0.0400255, 1.83159e-06
0.0500195, 1.80034e-06
0.0600134, 1.79221e-06
0.0700074, 1.80722e-06
0.080001, 1.83471e-06
0.089995, 1.86846e-06
0.099989, 1.91097e-06
0.109983, 1.95597e-06
0.119977, 2.01034e-06
0.129971, 2.0647199999999996e-06
0.139964, 2.12472e-06
0.149958, 2.1847199999999997e-06
0.159952, 2.24847e-06
0.169946, 2.3140999999999996e-06
0.17994, 2.38285e-06
0.189934, 2.45285e-06
0.199928, 2.5272299999999997e-06
0.209922, 2.6016e-06
0.219916, 2.6778499999999997e-06
0.22991, 2.7603599999999996e-06
0.239904, 2.83848e-06
0.249897, 2.92598e-06
0.259891, 3.0097299999999997e-06
0.269885, 3.10161e-06
0.279879, 3.1884899999999998e-06
0.289873, 3.2828599999999997e-06
0.299867, 3.37974e-06
0.309861, 3.4766099999999997e-06
0.319855, 3.57912e-06
0.329849, 3.6916199999999996e-06
0.339843, 3.8116199999999998e-06
0.349837, 3.947249999999999e-06
0.35983, 4.10975e-06
0.369824, 4.3034999999999995e-06
0.379818, 4.55726e-06
0.389812, 4.88539e-06
0.399806, 5.3385199999999995e-06
0.4098, 5.96853e-06
0.419794, 6.86542e-06
0.429788, 8.14106e-06
0.439782, 9.979839999999998e-06
0.449776, 1.25874e-05
0.45977, 1.6260599999999998e-05
0.469764, 2.1328399999999997e-05
0.479757, 2.8134799999999997e-05
0.489751, 3.68787e-05
0.499745, 4.7953899999999995e-05
0.509739, 6.13541e-05
0.519733, 7.682299999999999e-05
0.529727, 9.407959999999999e-05
0.539721, 0.000113074
0.549715, 0.000133168
0.559709, 0.000154349
0.569703, 0.000175962
0.579696, 0.000197847
0.58969, 0.000219472
0.599684, 0.000240285
0.609678, 0.000259785
0.619672, 0.000277348
0.629666, 0.000292473
0.63966, 0.00030391099999999997
0.649654, 0.000311723
0.659648, 0.000314224
0.669642, 0.000311911
0.679635, 0.000303973
0.689629, 0.000292786
0.699623, 0.000279911
0.709617, 0.000267473
0.719611, 0.000257035
0.729605, 0.000247348
0.739599, 0.000239972
0.749593, 0.00023278499999999997
0.759587, 0.000227785
0.769581, 0.00022278499999999998
0.779574, 0.000219347
0.789568, 0.00021659699999999999
0.799562, 0.000214472
0.809556, 0.000214222
0.81955, 0.00021415899999999998
0.829544, 0.000215972
0.839538, 0.00021828499999999997
0.849532, 0.000223097
0.859526, 0.00022828499999999997
0.86952, 0.000236222
0.879513, 0.000244972
0.889507, 0.00025516
0.899501, 0.000266598
0.909495, 0.00027878500000000004
0.919489, 0.000292286
0.929483, 0.000305286
0.939477, 0.00031884899999999996
0.949471, 0.000331411
0.959465, 0.00034334899999999995
0.969459, 0.00035359899999999996
0.979453, 0.000361974
0.989446, 0.00036816199999999995
0.99944, 0.00037116199999999997
1.00943, 0.000371349
1.01943, 0.000368099
1.02942, 0.00036259899999999996
1.03942, 0.00035447399999999997
1.04941, 0.00034528699999999995
1.0594, 0.000335536
1.0694, 0.00032622399999999996
1.07939, 0.00031759899999999995
1.08939, 0.000309223
1.09938, 0.000301911
1.10937, 0.000294786
1.11937, 0.000288911
1.12936, 0.000282973
1.13935, 0.00027766
1.14935, 0.00027291
1.15934, 0.000267973
1.16934, 0.000264285
1.17933, 0.00025941
1.18932, 0.00025666
1.19932, 0.000252223
1.20931, 0.000249473
1.21931, 0.00024616
1.2293, 0.00024316
1.23929, 0.00024040999999999998
1.24929, 0.00023728499999999998
1.25928, 0.00023541
1.26928, 0.000232097
1.27927, 0.000230597
1.28926, 0.000227347
1.29926, 0.00022616
1.30925, 0.000223347
1.31925, 0.000221285
1.32924, 0.000219472
1.33923, 0.000217347
1.34923, 0.00021616
1.35922, 0.000213972
1.36921, 0.000212409
1.37921, 0.00021028399999999998
1.3892, 0.000209222
1.3992, 0.000207222
1.40919, 0.00020615899999999998
1.41918, 0.00020428399999999997
1.42918, 0.000203097
1.43917, 0.000201347
1.44917, 0.000200222
1.45916, 0.000198909
1.46915, 0.000197284
1.47915, 0.000196284
1.48914, 0.000194847
1.49914, 0.00019378399999999999
1.50913, 0.000192222
1.51912, 0.000191347
1.52912, 0.000190222
1.53911, 0.00018928399999999999
1.5491, 0.00018815899999999997
1.5591, 0.000186909
1.56909, 0.00018615899999999998
1.57909, 0.00018453399999999998
1.58908, 0.000184097
1.59907, 0.00018253399999999998
1.60907, 0.000182096
1.61906, 0.00018090899999999999
1.62906, 0.000180096
1.63905, 0.000179096
1.64904, 0.000178221
1.65904, 0.000177284
1.66903, 0.000176221
1.67903, 0.00017528399999999997
1.68902, 0.000174346
1.69901, 0.000174034
1.70901, 0.000172971
1.719, 0.00017228399999999998
1.729, 0.00017128399999999998
1.73899, 0.000170721
1.74898, 0.000170159
1.75898, 0.000169221
1.76897, 0.00016878399999999998
1.77896, 0.000168284
1.78896, 0.000168284
1.79895, 0.000168221
1.80895, 0.000168284
1.79895, 0.00016428399999999997
1.78896, 0.000162221
1.77896, 0.00016028399999999999
1.76897, 0.000159096
1.75898, 0.000158221
1.74898, 0.000157284
1.73899, 0.00015647099999999999
1.729, 0.00015578399999999998
1.719, 0.00015528399999999997
1.70901, 0.000154471
1.69901, 0.00015415899999999999
1.68902, 0.00015328399999999998
1.67903, 0.000153096
1.66903, 0.000152221
1.65904, 0.00015134599999999998
1.64904, 0.000151221
1.63905, 0.00015028399999999999
1.62906, 0.000150096
1.61906, 0.000148659
1.60907, 0.000149221
1.59907, 0.000147846
1.58908, 0.00014803299999999997
1.57909, 0.000146346
1.56909, 0.000146346
1.5591, 0.00014584599999999999
1.5491, 0.00014515899999999998
1.53911, 0.00014522099999999998
1.52912, 0.000143346
1.51912, 0.000144096
1.50913, 0.00014253299999999997
1.49914, 0.00014253299999999997
1.48914, 0.000142159
1.47915, 0.00014128399999999998
1.46915, 0.000141221
1.45916, 0.000140221
1.44917, 0.000140221
1.43917, 0.00013928299999999997
1.42918, 0.000139221
1.41918, 0.00013828299999999998
1.40919, 0.000138221
1.3992, 0.00013728299999999998
1.3892, 0.000137096
1.37921, 0.00013628299999999998
1.36921, 0.000136096
1.35922, 0.000135346
1.34923, 0.00013515799999999997
1.33923, 0.000134346
1.32924, 0.000134221
1.31925, 0.00013359599999999999
1.30925, 0.000133221
1.29926, 0.000132658
1.28926, 0.000132283
1.27927, 0.000132033
1.26928, 0.00013128299999999997
1.25928, 0.00013115799999999998
1.24929, 0.00013028299999999997
1.23929, 0.00013028299999999997
1.2293, 0.00012965799999999997
1.21931, 0.000129221
1.20931, 0.00012909599999999999
1.19932, 0.000128221
1.18932, 0.000128221
1.17933, 0.000127283
1.16934, 0.000127221
1.15934, 0.000126471
1.14935, 0.000126158
1.13935, 0.000125971
1.12936, 0.00012522099999999999
1.11937, 0.00012465799999999998
1.10937, 0.000124096
1.09938, 0.000123346
1.08939, 0.000122721
1.07939, 0.000122221
1.0694, 0.000121283
1.0594, 0.000120346
1.04941, 0.000119658
1.03942, 0.000118658
1.02942, 0.00011772099999999999
1.01943, 0.000116283
1.00943, 0.000115283
0.99944, 0.000114095
0.989446, 0.000112283
0.979453, 0.00011096999999999999
0.969459, 0.00010928299999999999
0.959465, 0.000107345
0.949471, 0.000105533
0.939477, 0.00010421999999999999
0.929483, 0.000102283
0.919489, 0.000101158
0.909495, 9.92827e-05
0.899501, 9.82828e-05
0.889507, 9.72202e-05
0.879513, 9.622029999999999e-05
0.86952, 9.528279999999999e-05
0.859526, 9.447029999999999e-05
0.849532, 9.42202e-05
0.839538, 9.34076e-05
0.829544, 9.32202e-05
0.81955, 9.297009999999999e-05
0.809556, 9.228249999999999e-05
0.799562, 9.228249999999999e-05
0.789568, 9.20951e-05
0.779574, 9.15327e-05
0.769581, 9.12826e-05
0.759587, 9.12826e-05
0.749593, 9.07826e-05
0.739599, 9.02827e-05
0.729605, 9.0095e-05
0.719611, 8.92825e-05
0.709617, 8.83451e-05
0.699623, 8.72827e-05
0.689629, 8.59702e-05
0.679635, 8.384489999999999e-05
0.669642, 8.08449e-05
0.659648, 7.678249999999999e-05
0.649654, 7.11572e-05
0.63966, 6.37197e-05
0.629666, 5.43447e-05
0.619672, 4.2719399999999996e-05
0.609678, 2.87817e-05
0.599684, 1.2843799999999999e-05
0.58969, -4.78125e-06
0.579696, -2.39692e-05
0.569703, -4.50226e-05
0.559709, -6.649789999999999e-05
0.549715, -8.86232e-05
0.539721, -0.00011074899999999999
0.529727, -0.000132774
0.519733, -0.000153912
0.509739, -0.000173712
0.499745, -0.00019065899999999998
0.489751, -0.00020553399999999997
0.479757, -0.00021716
0.469764, -0.000224535
0.45977, -0.000226347
0.449776, -0.000222222
0.439782, -0.000212409
0.429788, -0.00019865899999999998
0.419794, -0.000183409
0.4098, -0.000168846
0.399806, -0.00015584599999999998
0.389812, -0.00014465799999999998
0.379818, -0.000134908
0.369824, -0.000126471
0.35983, -0.000119033
0.349837, -0.000112533
0.339843, -0.00010672
0.329849, -0.00010146999999999999
0.319855, -9.66578e-05
0.309861, -9.24077e-05
0.299867, -8.84076e-05
0.289873, -8.471999999999999e-05
0.279879, -8.15325e-05
0.269885, -7.82825e-05
0.259891, -7.547e-05
0.249897, -7.271989999999999e-05
0.239904, -7.00948e-05
0.22991, -6.771980000000001e-05
0.219916, -6.57197e-05
0.209922, -6.36573e-05
0.199928, -6.15947e-05
0.189934, -5.9719700000000004e-05
0.17994, -5.77197e-05
0.169946, -5.59696e-05
0.159952, -5.4657099999999995e-05
0.149958, -5.27821e-05
0.139964, -5.1594599999999996e-05
0.129971, -4.978199999999999e-05
0.119977, -4.8781999999999995e-05
0.109983, -4.75321e-05
0.099989, -4.6031999999999996e-05
0.089995, -4.48444e-05
0.080001, -4.3781999999999995e-05
0.0700074, -4.31663e-05
0.0600134, -4.21225e-05
0.0500195, -4.11038e-05
0.0400255, -4.0134999999999994e-05
0.0300315, -3.92037e-05
0.0200379, -3.83037e-05
0.0100439, -3.74412e-05
4.99413E-05, -3.6591199999999996e-05
-0.00994404, -3.5797400000000004e-05
-0.019938, -3.49974e-05
-0.0299316, -3.42474e-05
-0.0399256, -3.35161e-05
-0.0499196, -3.28099e-05
-0.0599135, -3.21349e-05
-0.0699075, -3.14724e-05
-0.0799013, -3.08411e-05
-0.0898951, -3.02161e-05
-0.0998891, -2.96098e-05
-0.109883, -2.90286e-05
-0.119877, -2.84848e-05
-0.129871, -2.79223e-05
-0.139865, -2.74098e-05
-0.149859, -2.6878499999999997e-05
-0.159853, -2.6391e-05
-0.169846, -2.59098e-05
-0.17984, -2.5453499999999996e-05
-0.189834, -2.4991e-05
-0.199828, -2.4565999999999998e-05
-0.209822, -2.41472e-05
-0.219816, -2.3734699999999998e-05
-0.22981, -2.33597e-05
-0.239804, -2.2966e-05
-0.249798, -2.26347e-05
-0.259792, -2.2265999999999997e-05
-0.269785, -2.19472e-05
-0.279779, -2.1615999999999998e-05
-0.289773, -2.12972e-05
-0.299767, -2.1009699999999996e-05
-0.309761, -2.07284e-05
-0.319755, -2.04722e-05
-0.329749, -2.0203399999999997e-05
-0.339743, -2.00034e-05
-0.349737, -1.97972e-05
-0.359731, -1.9672199999999998e-05
-0.369724, -1.95847e-05
-0.379718, -1.95659e-05
-0.389712, -1.9634699999999997e-05
-0.399706, -1.97847e-05
-0.4097, -2.00472e-05
-0.419694, -2.0378399999999998e-05
-0.429688, -2.0759699999999997e-05
-0.439682, -2.11159e-05
-0.449676, -2.14159e-05
-0.45967, -2.15597e-05
-0.469663, -2.1497199999999998e-05
-0.479657, -2.12409e-05
-0.489651, -2.08222e-05
-0.499645, -2.03097e-05
-0.509639, -1.9765899999999997e-05
-0.519633, -1.92222e-05
-0.529627, -1.87097e-05
-0.539621, -1.82347e-05
-0.549615, -1.78097e-05
-0.559609, -1.74159e-05
-0.569602, -1.70659e-05
-0.579596, -1.6747099999999998e-05
-0.58959, -1.6447099999999997e-05
-0.599584, -1.6203399999999998e-05
-0.609578, -1.59846e-05
-0.619572, -1.5778399999999998e-05
-0.629566, -1.5622099999999997e-05
-0.63956, -1.5472099999999997e-05
-0.649554, -1.5365899999999998e-05
-0.659548, -1.52659e-05
-0.669541, -1.5203399999999999e-05
-0.679535, -1.51409e-05
-0.689529, -1.51096e-05
-0.699523, -1.5059599999999999e-05
-0.709517, -1.50409e-05
-0.719511, -1.5003399999999998e-05
-0.729505, -1.4965899999999998e-05
-0.739499, -1.49346e-05
-0.749493, -1.4909599999999999e-05
-0.759487, -1.48846e-05
-0.769481, -1.48721e-05
-0.779474, -1.4903399999999999e-05
-0.789468, -1.49846e-05
-0.799462, -1.5128399999999999e-05
-0.809456, -1.53221e-05
-0.81945, -1.55971e-05
-0.829444, -1.59534e-05
-0.839438, -1.6353399999999998e-05
-0.849432, -1.68159e-05
-0.859426, -1.7265899999999997e-05
-0.86942, -1.7709599999999997e-05
-0.879413, -1.80972e-05
-0.889407, -1.84534e-05
-0.899401, -1.87097e-05
-0.909395, -1.89222e-05
-0.919389, -1.90472e-05
-0.929383, -1.9078399999999997e-05
-0.939377, -1.90409e-05
-0.949371, -1.89034e-05
-0.959365, -1.8684699999999997e-05
-0.969359, -1.8384699999999997e-05
-0.979353, -1.8034600000000002e-05
-0.989347, -1.76221e-05
-0.99934, -1.72221e-05
-1.00933, -1.67909e-05
-1.01933, -1.63846e-05
-1.02932, -1.59909e-05
-1.03932, -1.56346e-05
-1.04931, -1.5315899999999997e-05
-1.0593, -1.50159e-05
-1.0693, -1.47408e-05
-1.07929, -1.4503299999999999e-05
-1.08929, -1.4278299999999998e-05
-1.09928, -1.40783e-05
-1.10927, -1.38971e-05
-1.11927, -1.37283e-05
-1.12926, -1.35721e-05
-1.13926, -1.3465799999999999e-05
-1.14925, -1.33533e-05
-1.15924, -1.32783e-05
-1.16924, -1.32408e-05
-1.17923, -1.32283e-05
-1.18922, -1.32721e-05
-1.19922, -1.33596e-05
-1.20921, -1.35096e-05
-1.21921, -1.37096e-05
-1.2292, -1.39471e-05
-1.23919, -1.42283e-05
-1.24919, -1.4503299999999999e-05
-1.25918, -1.47596e-05
-1.26918, -1.49846e-05
-1.27917, -1.5247099999999998e-05
-1.28916, -1.5503399999999998e-05
-1.29916, -1.58159e-05
-1.30915, -1.61659e-05
-1.31915, -1.65284e-05
-1.32914, -1.6959599999999996e-05
-1.33913, -1.7322099999999998e-05
-1.34913, -1.7703399999999997e-05
-1.35912, -1.79721e-05
-1.36911, -1.82284e-05
-1.37911, -1.8459700000000002e-05
-1.3891, -1.86597e-05
-1.3991, -1.88659e-05
-1.40909, -1.90472e-05
-1.41908, -1.92159e-05
-1.42908, -1.93534e-05
-1.43907, -1.94909e-05
-1.44907, -1.95909e-05
-1.45906, -1.9690899999999998e-05
-1.46905, -1.97534e-05
-1.47905, -1.98784e-05
-1.48904, -1.99972e-05
-1.49904, -2.01472e-05
-1.50903, -2.0328399999999997e-05
-1.51902, -2.0509699999999998e-05
-1.52902, -2.0753399999999997e-05
-1.53901, -2.09847e-05
-1.549, -2.12722e-05
-1.559, -2.15535e-05
-1.56899, -2.19035e-05
-1.57899, -2.22347e-05
-1.58898, -2.2615999999999998e-05
-1.59897, -2.2990999999999997e-05
-1.60897, -2.34035e-05
-1.61896, -2.3822199999999997e-05
-1.62896, -2.4253499999999997e-05
-1.63895, -2.4690999999999998e-05
-1.64894, -2.51535e-05
-1.65894, -2.56098e-05
-1.66893, -2.6072299999999998e-05
-1.67893, -2.65473e-05
-1.68892, -2.6997299999999996e-05
-1.69891, -2.74598e-05
-1.70891, -2.79223e-05
-1.7189, -2.83723e-05
-1.7289, -2.88348e-05
-1.73889, -2.92723e-05
-1.74888, -2.97348e-05
-1.75888, -3.01661e-05
-1.76887, -3.06286e-05
-1.77886, -3.10598e-05
-1.78886, -3.1509899999999995e-05
-1.79885, -3.19536e-05
-1.80885, -3.2397399999999996e-05
-1.79885, -2.8303599999999998e-05
-1.78886, -2.5203499999999997e-05
-1.77886, -2.2703499999999997e-05
-1.76887, -2.0634699999999997e-05
-1.75888, -1.88909e-05
-1.74888, -1.73784e-05
-1.73889, -1.60784e-05
-1.7289, -1.49159e-05
-1.7189, -1.39158e-05
-1.70891, -1.30221e-05
-1.69891, -1.22033e-05
-1.68892, -1.14908e-05
-1.67893, -1.08408e-05
-1.66893, -1.02783e-05
-1.65894, -9.69702e-06
-1.64894, -9.215769999999999e-06
-1.63895, -8.77826e-06
-1.62896, -8.378259999999998e-06
-1.61896, -7.9845e-06
-1.60897, -7.61575e-06
-1.59897, -7.28449e-06
-1.58898, -6.984479999999999e-06
-1.57899, -6.703229999999999e-06
-1.56899, -6.47198e-06
-1.559, -6.18447e-06
-1.549, -5.97821e-06
-1.53901, -5.76571e-06
-1.52902, -5.55946e-06
-1.51902, -5.35321e-06
-1.50903, -5.17195e-06
-1.49904, -4.9782e-06
-1.48904, -4.7907099999999996e-06
-1.47905, -4.6406999999999995e-06
-1.46905, -4.48444e-06
-1.45906, -4.31569e-06
-1.44907, -4.176e-06
-1.43907, -4.02662e-06
-1.42908, -3.87537e-06
-1.41908, -3.75287e-06
-1.40909, -3.5922399999999995e-06
-1.3991, -3.4841199999999995e-06
-1.3891, -3.3234899999999998e-06
-1.37911, -3.21349e-06
-1.36911, -3.0722299999999996e-06
-1.35912, -2.94348e-06
-1.34913, -2.81973e-06
-1.33913, -2.68223e-06
-1.32914, -2.5697299999999997e-06
-1.31915, -2.4284699999999997e-06
-1.30915, -2.3153499999999998e-06
-1.29916, -2.18035e-06
-1.28916, -2.0697199999999996e-06
-1.27917, -1.94222e-06
-1.26918, -1.83472e-06
-1.25918, -1.7215899999999999e-06
-1.24919, -1.61846e-06
-1.23919, -1.51784e-06
-1.2292, -1.42346e-06
-1.21921, -1.34346e-06
-1.20921, -1.25658e-06
-1.19922, -1.1909599999999999e-06
-1.18922, -1.12033e-06
-1.17923, -1.06658e-06
-1.16924, -1.00533e-06
-1.15924, -9.59703e-07
-1.14925, -9.072019999999999e-07
-1.13926, -8.65326e-07
-1.12926, -8.247009999999999e-07
-1.11927, -7.81574e-07
-1.10927, -7.465739999999999e-07
-1.09928, -7.04699e-07
-1.08929, -6.74073e-07
-1.07929, -6.31572e-07
-1.0693, -6.04697e-07
-1.0593, -5.62196e-07
-1.04931, -5.3032e-07
-1.03932, -4.95945e-07
-1.02932, -4.60944e-07
-1.01933, -4.2781799999999997e-07
-1.00933, -3.87819e-07
-0.99934, -3.57819e-07
-0.989347, -3.19068e-07
-0.979353, -2.89536e-07
-0.969359, -2.51598e-07
-0.959365, -2.1584700000000001e-07
-0.949371, -1.79847e-07
-0.939377, -1.4378299999999998e-07
-0.929383, -1.09095e-07
-0.919389, -7.09074e-08
-0.909395, -3.86569e-08
-0.899401, 1.90616e-09
-0.889407, 3.2656699999999996e-08
-0.879413, 7.24072e-08
-0.86942, 1.05345e-07
-0.859426, 1.4303399999999998e-07
-0.849432, 1.74096e-07
-0.839438, 2.08347e-07
-0.829444, 2.41222e-07
-0.81945, 2.7241e-07
-0.809456, 3.0453599999999994e-07
-0.799462, 3.31411e-07
-0.789468, 3.58974e-07
-0.779474, 3.85787e-07
-0.769481, 4.13725e-07
-0.759487, 4.40413e-07
-0.749493, 4.66476e-07
-0.739499, 4.91164e-07
-0.729505, 5.17227e-07
-0.719511, 5.44102e-07
-0.709517, 5.679769999999999e-07
-0.699523, 5.93415e-07
-0.689529, 6.17916e-07
-0.679535, 6.46229e-07
-0.669541, 6.683539999999999e-07
-0.659548, 6.96979e-07
-0.649554, 7.18855e-07
-0.63956, 7.46293e-07
-0.629566, 7.696049999999999e-07
-0.619572, 7.964809999999999e-07
-0.609578, 8.21419e-07
-0.599584, 8.47482e-07
-0.58959, 8.737319999999999e-07
-0.579596, 9.00733e-07
-0.569602, 9.26233e-07
-0.559609, 9.53358e-07
-0.549615, 9.786089999999999e-07
-0.539621, 1.00855e-06
-0.529627, 1.0334799999999998e-06
-0.519633, 1.0632399999999999e-06
-0.509639, 1.08867e-06
-0.499645, 1.12074e-06
-0.489651, 1.14542e-06
-0.479657, 1.1778e-06
-0.469663, 1.2050499999999998e-06
-0.45967, 1.23649e-06
-0.449676, 1.2638e-06
-0.439682, 1.29661e-06
-0.429688, 1.32424e-06
-0.419694, 1.35524e-06
-0.4097, 1.38461e-06
-0.399706, 1.41555e-06
-0.389712, 1.4453e-06
-0.379718, 1.4764900000000001e-06
-0.369724, 1.50668e-06
-0.359731, 1.5379899999999999e-06
-0.349737, 1.56943e-06
-0.339743, 1.59974e-06
-0.329749, 1.63471e-06
-0.319755, 1.67034e-06
-0.309761, 1.7022099999999998e-06
-0.299767, 1.73534e-06
-0.289773, 1.76847e-06
-0.279779, 1.80409e-06
-0.269785, 1.8397199999999999e-06
-0.259792, 1.87597e-06
-0.249798, 1.91347e-06
-0.239804, 1.95034e-06
-0.22981, 1.98972e-06
-0.219816, 2.0309699999999997e-06
-0.209822, 2.0697199999999996e-06
-0.199828, 2.1097199999999996e-06
-0.189834, 2.15347e-06
-0.17984, 2.1978399999999998e-06
-0.169846, 2.2416e-06
-0.159853, 2.28847e-06
-0.149859, 2.33222e-06
-0.139865, 2.3797199999999996e-06
-0.129871, 2.4278499999999995e-06
-0.119877, 2.4740999999999997e-06
-0.109883, 2.52098e-06
-0.0998891, 2.5672299999999997e-06
-0.0898951, 2.61348e-06
-0.0799013, 2.65973e-06
-0.0699075, 2.70535e-06
-0.0599135, 2.75598e-06
-0.0499196, 2.8028599999999996e-06
-0.0399256, 2.85223e-06
-0.0299316, 2.90661e-06
-0.019938, 2.9597299999999998e-06
-0.00994404, 3.00848e-06
##END=$$ End of the data block


`;

export default cyclicVoltaJcamp3;
